import React, { useState, useEffect } from "react";
import history from "../../history";
import { connect } from "react-redux";
import { InputGroup, Dropdown } from "react-bootstrap";
import {
  UPDATE_IS_CROSS_SCHOOL_SEARCH,
  UPDATE_CROSS_SCHOOL_SEARCH_VALUE,
  UPDATE_CROSS_SCHOOL_SEARCH_FIELD,
  UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH,
  UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH
} from "../../actions/types";
import PermissionComponentCheck from "../PermissionComponents/PermissionComponentCheck";
import PersistentTooltip from "../Menus/PersistentTooltip";

const CrossSchoolSearchInput = ({dispatch, crossSchoolSearchStore, sidName}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (crossSchoolSearchStore.clearSearch === true) {
      setValue("");
      dispatch({
        type: UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH,
        payload: false
      });
    }
  }, [dispatch, crossSchoolSearchStore])

  const updateText = (value) => {
    setValue(value);
    dispatch({
      type: UPDATE_CROSS_SCHOOL_SEARCH_VALUE,
      payload: value
    });
  };
  const performSearch = (field) => {
    // Set the field to search on
    dispatch({
      type: UPDATE_CROSS_SCHOOL_SEARCH_FIELD,
      payload: field
    });

    // Set doSearch to true so a search is performed as soon as page is reached, or one is reperformed if alreay on the page
    dispatch({
      type: UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH,
      payload: true
    });

    // Check current url
    if (window.location.hash !== "#/userSearch") {
      // redirect to user search page
      history.push("/userSearch");
    }
  };
  return (
    <div className="ml-2">
      <InputGroup id="CrossSchoolSearchInput" className="flex-nowrap">
        <InputGroup.Prepend>
          <PersistentTooltip
            placement="bottom"
            className="ml-2"
            style={{ display: "flex" }}
            overlay={
              crossSchoolSearchStore.isCrossSchoolSearch
                ? "You are searching across all schools, click here to search only on the current school"
                : "You are currently searching only within the current school, click here to search across all schools"
            }
          >
            <PermissionComponentCheck
              requiredPermission="CROSS_SCHOOL_SEARCH"
              denyAction="showAlternative"
              alternativeComponent={
                <InputGroup.Text>
                  <i className="fas fa-university" />
                </InputGroup.Text>
              }
            >
              <InputGroup.Text
                onClick={() =>
                  dispatch({
                    type: UPDATE_IS_CROSS_SCHOOL_SEARCH,
                    payload: !crossSchoolSearchStore.isCrossSchoolSearch
                  })
                }
              >
                <i
                  className={
                    crossSchoolSearchStore.isCrossSchoolSearch
                      ? "fas fa-unlock"
                      : "fas fa-university"
                  }
                />
              </InputGroup.Text>
            </PermissionComponentCheck>
          </PersistentTooltip>
        </InputGroup.Prepend>
        <input
          type="text"
          className="form-control"
          value={value}
          placeholder="Search"
          aria-label="Search"
          onChange={(e) => {
            e.preventDefault();
            updateText(e.target.value);
          }}
          onKeyPress={event => {
            if (event.key === "Enter") {
              performSearch("lastName");
            }
          }}
        />
        <InputGroup.Append>
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              className="dropdown-button"
              aria-label="search-dropdown-button"
              id="search-dropdown-button"
            ></Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => performSearch("lastName")}>
                Search by Last Name
              </Dropdown.Item>
              <Dropdown.Item onClick={() => performSearch("ssnLastFour")}>
                Search by last 4 digits of SSN
              </Dropdown.Item>
              <Dropdown.Item onClick={() => performSearch("address1")}>
                Search by Address Line 1
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => performSearch("studentEmailAddress")}
              >
                Search by Email Address
              </Dropdown.Item>
              <Dropdown.Item onClick={() => performSearch("phoneNumber")}>
                Search by Mobile Number
              </Dropdown.Item>
              <Dropdown.Item onClick={() => performSearch("dob")}>
                Search by Date of Birth
              </Dropdown.Item>
              <Dropdown.Item onClick={() => performSearch("sid")}>
                Search by {sidName}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </InputGroup.Append>
      </InputGroup>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    sidName: state.school.school?.sidName,
    crossSchoolSearchStore: state.crossSchoolSearchStore
  };
};

export default connect(mapStateToProps)(CrossSchoolSearchInput);
